import { merge } from 'lodash'

export default function (existingModel = {}) {
  return {
    model: merge(
      {
        paddockId: null,
        price: null,
        startAt: null,
        startDate: null,
        startTime: null,
        sessionLength: null
      },
      existingModel
    ),
    validation: {
      paddockId: { required: true },
      startAt: { required: true },
      endAt: { required: true }
    }
  }
}
